import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const CheckIdeaStatusIcon: React.FC<IStyledSVGIconProps> = (
  props
) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="26.002" 
      height="26" 
      viewBox="0 0 26.002 26"
      style={{ enableBackground: "new 0 0 48 48;" }}
      xmlSpace="preserve"
      {...props}
    >
      <g id="Group_453" data-name="Group 453">
        <path id="Path_126" data-name="Path 126" d="M9.3,7.583a3.354,3.354,0,0,0,3.25-3.358V3.358A3.361,3.361,0,0,0,11.571.975,3.218,3.218,0,0,0,9.35,0,3.343,3.343,0,0,0,6.1,3.3v.921a3.361,3.361,0,0,0,.975,2.383A3.119,3.119,0,0,0,9.3,7.583Z" transform="translate(-2.796)" fill="#007bc3"/>
        <path id="Path_127" data-name="Path 127" d="M9.208,32.875h1.083V26.212A3.965,3.965,0,0,0,13,23.017V19.225A4.36,4.36,0,0,0,8.667,15H4.333A4.392,4.392,0,0,0,0,19.225v3.792a3.639,3.639,0,0,0,2.708,3.2v6.662H3.792" transform="translate(0 -6.875)" fill="#007bc3"/>
        <rect id="Rectangle_1111" data-name="Rectangle 1111" width="1" height="9" transform="translate(6 17)" fill="#fff"/>
        <path id="Path_128" data-name="Path 128" d="M29,17v4.875h3.25V20.792H30.083V17Z" transform="translate(-13.292 -7.792)" fill="#007bc3"/>
        <path id="Path_129" data-name="Path 129" d="M30.792,8.462a9.784,9.784,0,0,0-10.292,0l.6.921A8.65,8.65,0,0,1,30.25,24.062a8.707,8.707,0,0,1-9.154,0l-.6.921A9.732,9.732,0,1,0,30.792,8.462Z" transform="translate(-9.396 -3.208)" fill="#007bc3"/>
        <path id="Path_130" data-name="Path 130" d="M22.742,24.946a6.862,6.862,0,0,0,3.683,1.137,7.042,7.042,0,0,0,0-14.083A6.888,6.888,0,0,0,22.2,13.462l.65.867a5.739,5.739,0,0,1,3.575-1.246,5.958,5.958,0,0,1,0,11.917,5.778,5.778,0,0,1-3.087-.975Z" transform="translate(-10.175 -5.5)" fill="#007bc3"/>
      </g>
      <rect id="Rectangle_1112" data-name="Rectangle 1112" width="0.542" height="8.667" transform="translate(10.346 13.379)" fill="#fff"/>
      <path id="Path_131" data-name="Path 131" d="M3.9,24.9h.542v8.667H3.9" transform="translate(-1.788 -11.413)" fill="#fff"/>
    </StyledSVGIcon>
  );
};
